

import { FormControl, AbstractControl } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';

//
// Returns the strength of the current password
//
export function checkPasswordStrength(control: AbstractControl): ValidationErrors {

  const password = control.value;

  let numberOfElementsLower = 0;
  let numberOfElementsUpper = 0;
  let numberOfElementsNumbers = 0;
  let numberOfElementsSpecial = 0;
  numberOfElementsLower = /.*[a-z].*/.test(password) ? ++numberOfElementsLower : numberOfElementsLower;
  numberOfElementsUpper = /.*[A-Z].*/.test(password) ? ++numberOfElementsUpper : numberOfElementsUpper;
  numberOfElementsNumbers = /.*[0-9].*/.test(password) ? ++numberOfElementsNumbers : numberOfElementsNumbers;
  numberOfElementsSpecial = /[^a-zA-Z0-9]/.test(password) ? ++numberOfElementsSpecial : numberOfElementsSpecial;

  if (password) {
    if (password.length < 8) {
      return { error: true, message: 'characters' };
    } else if (numberOfElementsUpper === 0) {
      return { error: true, message: 'uppercase' };
    } else if (numberOfElementsNumbers === 0) {
      return { error: true, message: 'number' };
    } else if (numberOfElementsSpecial === 0) {
      return { error: true, message: 'special' };
    }
  }

  return null;
}

